module.exports = __webpack_public_path__ + "media/src/images/viewbtn/fullsize-on-ad89530a1d5fb06086c7919d06f3ff75.png";